import { useContext, useState } from 'react'
import { ConfigurationContext } from '../../context api/Configuration/ConfigurationContext'
import { SuperAdminContext } from '../../context api/SuperAdmin/SuperAdminContext'
import { useRestApi } from '../../lib/RestApi/useRestApi'
import { API_URL } from '../../shared/actions'

export const useSuperAdmin = () => {
  const [superAdmin, setSuperAdmin] = useState(false)
  const { deleteNewSuperAdmin, getNewSuperAdmins } = useContext(SuperAdminContext)
  const [loading, setLoading] = useState(false)
  const [paginate, setPaginate] = useState(false)

  const { ADD, GET_ALL, UPDATE, GET_SINGLE_DATA, DELETE } = useRestApi(setLoading, 'subscriptions', 'ALL_SUPERADMINS', 'GET_ALL_SUPERADMINS')
  const {
    SUPERADMIN: { GET_ALL_SUPERADMINS, ADD_SUPERADMIN, EDIT_SUPERADMIN, GET_SUPERADMIN, DELETE_MANY_SUPERADMIN },
  } = API_URL

  const getAllSuperAdmin = async (dto = {}) => {
    GET_ALL(GET_ALL_SUPERADMINS, setPaginate, getNewSuperAdmins, dto)
  }

  const addSuperAdmin = (dto) => {
    ADD(ADD_SUPERADMIN, dto)
  }


  const updateSuperAdmin = (dto) => {
    UPDATE(EDIT_SUPERADMIN, dto)
  }

  const getSuperAdmin = (dto) => {
    GET_SINGLE_DATA(GET_SUPERADMIN, setSuperAdmin, dto)
  }

  const deleteManySuperAdmin = (dto, setSelected = () => {}) => {
    DELETE(DELETE_MANY_SUPERADMIN, dto, 'superAdminId', setSelected, deleteNewSuperAdmin, 'GET_ALL_SUPERADMINS')
  }

  return {
    addSuperAdmin,
    getAllSuperAdmin,
    getSuperAdmin,
    superAdmin,
    updateSuperAdmin,
    deleteManySuperAdmin,
    loading,
    paginate,
  }
}
